import { render, staticRenderFns } from "./modal-manage-files.vue?vue&type=template&id=d66e2fac&scoped=true&"
import script from "./modal-manage-files.vue?vue&type=script&lang=js&"
export * from "./modal-manage-files.vue?vue&type=script&lang=js&"
import style0 from "./modal-manage-files.vue?vue&type=style&index=0&id=d66e2fac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d66e2fac",
  null
  
)

export default component.exports